import { ReactNode, useContext, VFC } from 'react';

import SignatureRequestModal from '@/components/AccessTokenRequired/SignatureRequestModal';
import DefaultSpinner from '@/components/DefaultSpinner';
import { Web3Context } from '@/contexts/Web3Provider/Web3Provider';
import useAccessToken from '@/hooks/useAccessToken';

type Props = {
  children: ReactNode;
};

const AccessTokenRequired: VFC<Props> = ({ children }: Props) => {
  const { currentAccountAddress } = useContext(Web3Context);
  const { accessToken, loading: loadingAccessToken } = useAccessToken();

  // render spinner while loading
  if (loadingAccessToken) {
    return <DefaultSpinner />;
  }

  return (
    <>
      {(!currentAccountAddress || !accessToken) && <SignatureRequestModal />}
      {children}
    </>
  );
};

export default AccessTokenRequired;
